import React from "react";
import { TabPanel, Item } from "devextreme-react/tab-panel";
import SimulacoesComponent from "./simulacoes";
import ExportacaoCompleta from "./exportacaoCompleta";
import UnidadeFiscalBox from "../UnidadeFiscalBox";

export default class Simulacoes extends React.Component {
  constructor() {
    super();
    this.state = {
      index: 0,
    };
    
  }


  render() {
    return (
      <React.Fragment>
        <SimulacoesComponent />

     
      </React.Fragment>
    );
  }
}
